"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityLayout = void 0;
var utils_1 = require("../../utils");
exports.EntityLayout = {
  name: 'EntityLayout',
  type: 'taxonomy',
  icon: function (_a) {
    var icons = _a.icons;
    return icons.Entities.BlockLayout;
  },
  autoRoutes: ['list'],
  table: {
    fieldNames: ["preview", "name", "internalName"],
    fields: {
      preview: {
        weight: 1.5
      },
      internalName: {
        weight: 1
      }
    }
  },
  valueImageStyle: 'banner',
  list: {
    resultsVariant: 'list'
  },
  form: {
    fields: __assign(__assign({}, utils_1.entityStandardFormFields), {
      preview: {
        type: 'image',
        description: "Provide a screenshot of the design of this {{ENTITY_LAYOUT}}, for reference."
      },
      internalName: {
        type: 'text'
      },
      description: {
        type: 'longText',
        description: "Describe this {{ENTITY_LAYOUT}}."
      }
    })
  }
};